export const API_BASE_URL = "https://apiutilidades.lundingold.com/";
//export const API_BASE_URL = "http://localhost:8080/";
export const AUTH_TOKEN = "at_cli";
export const REFRESH_TOKEN = "rt_cli";
export const USER_INFO = "ue_cli";
